export enum AttachmentType {
  File = "File",
  Link = "Link",
  FileDescriptor = "FileDescriptor",
}
